// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import ProjectList from "../../../account/components/projects/ProjectList";
import { buildProjectItemJson } from "../../../account/components/projects/buildProjectJson";
import { fetcProjectList } from "../../actions/projectAdminActions";
import {
  StyledSelect,
  LoadingProgress,
  SnackbarMessage,
  SingleSwitch,
  NoItem
} from "imagus-components";
import ChipInput from "../../../global/components/ChipInput";
import InfiniteCalendarSelect from "../../../global/components/InfiniteCalendarSelect";
import { companyDialogMessages } from "../../../account/components/companies/CompileCompanytoJson";
import { ErrosDisplay } from "../../../account/containers/ErrosDisplay";
import type { ErrorsType } from "../../../account/types/UserFormType";
import { propComparator } from "../../../global/functions/StringOperations";
import ExportProjectToCsv from "./ExportProjectToCsv";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

type AdminProjectsStateType = {
  messageId: number,
  isFilterOpen: boolean,
  order: "createdDate" | "closeDate" | "projectName" | "companyName",
  suquence: "asc" | "desc",
  companies: Array<string>,
  start_date: Date | null,
  end_date: Date | null,
  errors: ErrorsType,
  snackOpen: boolean
};

class AdminProjects extends Component<*, AdminProjectsStateType> {
  constructor(props) {
    super(props);
    this.state = {
      messageId: 0,
      isFilterOpen: true,
      order: "createdDate",
      suquence: "asc",
      companies: [],
      start_date: null,
      end_date: null,
      errors: {},
      snackOpen: false
    };
  }

  componentDidMount() {
    this.props.actions.fetcProjectList();
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  openSnackbar = (messageId: number): * => {
    this.setState(
      { messageId: messageId },
      this.switchModalStatus("snackOpen")(true)
    );
  };

  setActionError = (errors: ErrorsType): * => {
    this.setState({
      errors: errors
    });
  };

  handleTypeChange = (e: Event): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };

  syncChange = (name: string, value: Array<*>): * => {
    this.setState({ [name]: value });
  };

  handleTextChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;
    this.setState({
      [name]: value
    });
  };

  syncDateChange = (name: string, date: Date): * => {
    this.setState({ [name]: date });
  };

  handleSwitchChange = (event: Event): * => {
    const name = event.target.name;
    const value = event.target.checked;
    this.setState({
      [name]: value
    });
  };

  render(): * {
    const projects = this.props.projects;
    let projectNode = null;
    let companyList = [];
    let projectList = [];

    if (projects) {
      if (projects.length === 0) {
        projectNode = <NoItem content="No Project has created yet." />;
      } else {
        if (this.state.order === "createdDate") {
          projects.sort(
            propComparator("auditCreationDate", false, null, null, true)
          );
        } else if (this.state.order === "closeDate") {
          projects.sort(propComparator("closeDate", false, null, null, true));
        } else if (this.state.order === "projectName") {
          projects.sort(propComparator("name", true));
        } else if (this.state.order === "companyName") {
          projects.sort(propComparator("company", true, "name"));
        }

        if (this.state.suquence === "desc") {
          projects.reverse();
        }

        for (let i = 0; i < projects.length; i++) {
          let company = projects[i].company;
          let index = companyList.findIndex(x => x.value === company.id);
          if (index < 0) {
            companyList.push({ value: company.id, label: company.name });
          }
          projectList.push(buildProjectItemJson(projects[i]));
        }
        companyList.sort(propComparator("label", true));

        projectNode = (
          <ProjectList
            projects={projectList}
            openSnackbar={this.openSnackbar}
            setActionError={this.setActionError}
            isAdmin
            canViewQuotes
            companyFilter={this.state.companies}
            dateStartFilter={this.state.start_date}
            dateEndFilter={this.state.end_date}
          />
        );
      }
    }

    const OrderList = [
      { value: "createdDate", label: "Project Created Date" },
      { value: "closeDate", label: "Project Close Date" },
      { value: "projectName", label: "Project Name" },
      { value: "companyName", label: "Company Name" }
    ];
    const SequenceList = [
      { value: "asc", label: "Ascending" },
      { value: "desc", label: "Descending" }
    ];

    if (!projectNode) {
      return (
        <div className="app-panel">
          <LoadingProgress />
        </div>
      );
    } else {
      return (
        <div className="app-panel">
          <div className="top-banner">
            <ErrosDisplay errors={this.state.errors} form="admin project" />
          </div>
          <SnackbarMessage
            open={this.state.snackOpen}
            handleModalStatus={this.switchModalStatus("snackOpen")}
            message={companyDialogMessages[this.state.messageId]}
          />
          <div className="app-panel-content">
            <Paper elevation={4} style={{ padding: "16px " }}>
              <SingleSwitch
                value={this.state.isFilterOpen}
                name="isFilterOpen"
                isRequired={false}
                label={["Show Criteria", "Hide Criteria"]}
                handleChange={this.handleSwitchChange}
              />
              <div style={{ float: "right" }}>
                <ExportProjectToCsv
                  projects={projectList}
                  companyFilter={this.state.companies}
                  dateStartFilter={this.state.start_date}
                  dateEndFilter={this.state.end_date}
                />
              </div>
              {this.state.isFilterOpen && (
                <Grid container spacing={24}>
                  <Grid item xs={12} md={6}>
                    <StyledSelect
                      value={this.state.order}
                      onChange={this.handleTypeChange}
                      name="order"
                      label="Order By"
                      isRequired={true}
                      menus={OrderList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <StyledSelect
                      value={this.state.suquence}
                      onChange={this.handleTypeChange}
                      name="suquence"
                      label="Ascend | Descend"
                      isRequired={true}
                      menus={SequenceList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InfiniteCalendarSelect
                      isRequired={false}
                      label="Select Start Date"
                      name="start_date"
                      value={this.state.start_date}
                      syncDateChange={this.syncDateChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InfiniteCalendarSelect
                      isRequired={false}
                      label="Select End Date"
                      name="end_date"
                      value={this.state.end_date}
                      syncDateChange={this.syncDateChange}
                      isEndDate
                    />
                  </Grid>
                  <Grid item xs={12} md={6} className="top-margin-10">
                    <ChipInput
                      name="companies"
                      label="Select Companies"
                      isMultiple
                      placeholder="All Companies"
                      tags={companyList}
                      value={this.state.companies}
                      syncChange={this.syncChange}
                    />
                  </Grid>
                </Grid>
              )}
            </Paper>
          </div>
          {projectNode}
        </div>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  user: state.v3account.user,
  projects: state.v3admin.project.projects
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetcProjectList }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProjects);
